// extracted by mini-css-extract-plugin
export default {"header_wrapper":"SectionHeader_header_wrapper__XvPPn"};